<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="$l('table_search_placeholder')"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_hxFtyNoticeInStatus') || '状态'"
            >
              <el-checkbox-group v-model="form.listHxFtyNoticeInStatus">
                <el-checkbox label="N">
                  {{ $l('form_label_hxFtyNoticeInStatus_N') || '新增' }}
                </el-checkbox>
                <el-checkbox label="S">
                  {{ $l('form_label_hxFtyNoticeInStatus_S') || '已通知' }}
                </el-checkbox>
                <el-checkbox label="F">
                  {{ $l('form_label_hxFtyNoticeInStatus_F') || '已确认' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_hxFtyNoticeInStatus_Y') || '已入库' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('form_label_hxFtyNoticeInStatus_D') || '已删除' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_hxFtyNoticeInNo') || '入库通知书编号'"
            >
              <el-input
                v-model.trim="form.hxFtyNoticeInNo"
                :placeholder="
                  $l('form_placeholder_hxFtyNoticeInNo') || '请输入...'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_buyer') || '跟单业务'">
              <dict-select
                v-model="form.listBuyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_buyer') || '请选择...'"
                filterable
                multiple
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_ecomWarehouse') || '入库仓库'">
              <dict-select
                v-model="form.listEcomWarehouseCode"
                url="/ecom/warehouse/cn/warehouse/select"
                :placeholder="
                  $l('form_placeholder_ecomWarehouse') || '请选择...'
                "
                filterable
                multiple
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_scm') || '供应商'">
              <dict-select
                v-model="form.listScmCode"
                url="/master/common/dict/scmCooperated"
                :placeholder="$l('form_placeholder_scm') || '请选择...'"
                filterable
                multiple
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_cust') || '下单客户'">
              <dict-select
                v-model="form.listCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('form_placeholder_cust') || '请选择...'"
                filterable
                multiple
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_endCust') || '终端客户'">
              <dict-select
                v-model="form.listEndCustCode"
                url="/master/common/dict/customerSelect"
                :placeholder="$l('form_placeholder_endCust') || '请选择...'"
                filterable
                multiple
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_deliveryDate') || '预约日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_deliveryDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.deliveryDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_deliveryDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('form_label_comfirmDeliveryDate') || '送达日期'"
              >
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.comfirmDeliveryDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_comfirmDeliveryDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.comfirmDeliveryDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_comfirmDeliveryDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_createDate') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_createDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_createDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_modifyDate') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="
                      $l('form_placeholder_modifyDate') || '选择日期'
                    "
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', listHxFtyNoticeInStatus: ['N', 'S', 'F', 'Y'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
